import { render, staticRenderFns } from "./detail-cn-supplier.vue?vue&type=template&id=58f8081f"
import script from "./detail-cn-supplier.vue?vue&type=script&lang=js"
export * from "./detail-cn-supplier.vue?vue&type=script&lang=js"
import style0 from "./detail-cn-supplier.vue?vue&type=style&index=0&id=58f8081f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports